/* MODHAX — ヘッダー/フッターのアンカーリンク（CHARACTER / ABOUT US / SECRET） */
(function () {
  'use strict';
  if (window.__mxAnchorLoaded) return;
  window.__mxAnchorLoaded = true;

  function reduce() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function targetOf(a) {
    var href = (a.getAttribute('href') || '').toLowerCase();
    var txt = (a.textContent || '').toUpperCase().replace(/[^A-Z]/g, '');
    var i = href.indexOf('#');
    if (i > -1) {
      var h = href.slice(i);
      if (h.indexOf('secret') > -1) return 'secret';
      if (h.indexOf('about') > -1) return 'about';
      if (h.indexOf('character') > -1 || h.indexOf('select') > -1) return 'character';
    }
    if (txt === 'SECRET' || txt === 'SPELL') return 'secret';
    if (txt === 'ABOUTUS' || txt === 'ABOUT') return 'about';
    if (txt === 'CHARACTER' || txt === 'CHARACTERS') return 'character';
    return null;
  }

  function sectionFor(t) {
    if (t === 'about') return document.querySelector('.mx-sec--about');
    if (t === 'secret') return document.querySelector('.mx-sec--secret');
    var s = document.querySelector('.mx-sec--select') ||
            document.querySelector('[data-mx-select]');
    if (!s) return null;
    return (s.closest && s.closest('.mx-sec')) || s;
  }

  function closeDrawer() {
    var d = document.getElementById('mhxDrawer');
    if (d) d.classList.remove('is-open');
    var s = document.getElementById('mhxSearchDrawer');
    if (s) s.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function bind() {
    var sel = '.mhx-header a, .mhx-drawer a, .modhax-footer a';
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) {
      (function (a) {
        if (a.dataset.mxAnchor2 === '1') return;
        var t = targetOf(a);
        if (!t) return;
        a.dataset.mxAnchor2 = '1';
        a.dataset.mxAnchor = '1';
        a.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey) return;
          var sec = sectionFor(t);
          if (!sec) { e.preventDefault(); window.location.href = '/#' + t; return; }
          e.preventDefault();
          closeDrawer();
          sec.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth' });
          if (window.history && history.replaceState) history.replaceState(null, '', '#' + t);
        });
      })(list[i]);
    }
  }

  function fromHash() {
    var h = (location.hash || '').toLowerCase();
    if (!h) return;
    var t = null;
    if (h.indexOf('secret') > -1) t = 'secret';
    else if (h.indexOf('about') > -1) t = 'about';
    else if (h.indexOf('character') > -1 || h.indexOf('select') > -1) t = 'character';
    if (!t) return;
    setTimeout(function () {
      var sec = sectionFor(t);
      if (sec) sec.scrollIntoView({ behavior: 'auto' });
    }, 250);
  }

  function boot() { bind(); fromHash(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', bind);
  window.addEventListener('hashchange', fromHash);
  document.addEventListener('shopify:section:load', bind);
})();
